import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';


@Component({
  selector: 'sx-template-listado',
  templateUrl: 'templateList.component.html'
})
export class TemplateListadoComponent implements OnInit {
  @Input() titulo: string;
  @Input() subtitulo: string;
  @Input() listado: Observable<TemplateListadoItem[]>;
  @Input() link: (TemplateListadoItem) => string[] = (item) => ['./', item.id];
  buscar;

  constructor(private router: Router,
              private aRoute: ActivatedRoute) { }

  ngOnInit() {
  }
  volver(){
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/templateList/templateList.component.ts